module.exports = __webpack_public_path__ + "static/media/city-sound-new01_mixdown.4c22c443.mp3";